import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import NumbersAnimationProvider from 'app/components/AnimationProviders/NumbersAnimationProvider'
import UserProtrackDoneCommitDetails from './UserProtrackDoneCommitDetails'
import { getIdentityInitials, getIdentityAvatar, getCurrentProTrackProgress } from 'store/entities/identity/selectors'

const mapStateToProps = createStructuredSelector({
  initials: getIdentityInitials,
  avatar: getIdentityAvatar,
  proTrackLevelProgress: getCurrentProTrackProgress,
})

export default connect(mapStateToProps)(NumbersAnimationProvider(UserProtrackDoneCommitDetails))
